import _slicedToArray from "/codebuild/output/src182831320/src/scottschedule/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import _regeneratorRuntime from "/codebuild/output/src182831320/src/scottschedule/node_modules/@babel/runtime/regenerator/index.js";
import { __awaiter } from "tslib";
import { Auth } from 'aws-amplify';
import { getSortedFormFields } from '@aws-amplify/ui';
import { areEmptyArrays, areEmptyObjects } from '../../../utils';
import { COMPONENT_ROUTE_KEYS } from './constants';
export var defaultComparator = function defaultComparator() {
  return false;
};
/**
 * Does an ordering and shallow comparison of each array value,
 * plus a value equality check for empty objects and arrays.
 */
export function areSelectorDepsEqual(currentDeps, nextDeps) {
  if (currentDeps.length !== nextDeps.length) {
    return false;
  }
  return currentDeps.every(function (currentDep, index) {
    var nextDep = nextDeps[index];
    if (areEmptyArrays(currentDep, nextDep) || areEmptyObjects(currentDep, nextDep)) {
      return true;
    }
    return currentDep === nextDep;
  });
}
export var getComparator = function getComparator(selector) {
  return function (currentFacade, nextFacade) {
    var currentSelectorDeps = selector(currentFacade);
    var nextSelectorDeps = selector(nextFacade);
    // Shallow compare the array values
    return areSelectorDepsEqual(currentSelectorDeps, nextSelectorDeps);
  };
};
export var getTotpSecretCodeCallback = function getTotpSecretCodeCallback(user) {
  return function getTotpSecretCode() {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Auth.setupTOTP(user);
            case 2:
              return _context.abrupt("return", _context.sent);
            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
export var isComponentRouteKey = function isComponentRouteKey(route) {
  return COMPONENT_ROUTE_KEYS.some(function (componentRoute) {
    return componentRoute === route;
  });
};
var flattenFormFields = function flattenFormFields(fields) {
  return fields.flatMap(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      options = _ref2[1];
    return Object.assign({
      name: name
    }, options);
  });
};
/**
 * Retrieves legacy form field values from state machine for routes that have fields
 */
export var getLegacyFields = function getLegacyFields(route, state) {
  return (
    // verifyUser is a component route, but does not have form fields
    isComponentRouteKey(route) && route !== 'verifyUser' ? flattenFormFields(getSortedFormFields(route, state)) : []
  );
};